// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"2e6f2243","486":"2e6f2243","624":"3dae306b","971":"2e6f2243"}[chunkId] + ".chunk.css";
};